// Port de app/onboarding-prestador.tsx.
import { Carregando } from "@/app/Carregando";
import { lazy } from "react";

const OnboardingPrestadorScreen = lazy(() => import("@/screens/OnboardingPrestador"));

export default function OnboardingPrestadorRoute() {
  return (
    <Carregando cor="#294956">
      <OnboardingPrestadorScreen />
    </Carregando>
  );
}
